import { Component,OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { InsuranceApiService } from "@services/rest/insurance-api.service";
import { RoadTaxApiService } from "@services/rest/road-tax-api.service";
import { ActualPremiumModel, CustomerInfoModel,  QuotationRequestModel, QuotationResponseModel, VerifyVehicleReponseModel, 
  VerifyCustomerRequestModel, AgentInfoModel, VehicleInfoModel, UpdateSelectedInsuranceModel, CommissionSettings, 
  UpdateQuotationSpecialRequestModel} from "@model/quotation.model";
import { CalculateRoadTaxRequestModel, RoadTaxSettings } from "@model/road-tax.model";
import { NgxSpinnerService } from "ngx-spinner";
import { GeneraliApiService } from '@services/rest/generali-api.service';
import { ZurichApiService } from '@services/rest/zurich-api.service';
import { KurniaApiService } from '@services/rest/kurnia-api.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { format, } from 'date-fns'
import { QuotationApiService } from '@services/rest/quotation-api.service';
import { ChubbApiService } from '@services/rest/chubb-api.service';
import { bindPostCodeValidator, getState } from '@validator/postcode.validator';
import { catchError, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { PaymentResponseModel } from '@model/invoice.model';
import { NzMessageService } from 'ng-zorro-antd/message';
import { InsuranceCompanyConstant } from '@constants/insurance-company-constant';
import { CoveragesConstant } from '@constants/coverages-constant';
import { ValidateAlphanumeric } from '@validator/alphanumeric.validator';
import { UserModel } from '@model/staff.model';
import { ActivatedRoute, Router } from '@angular/router';
import { SupportApiService } from '@services/rest/support-api.service';
import { WhatsappRequestModel } from '@model/support.model';
import { CustomerApiService } from '@services/rest/customer-api.service';
import { CustomerRequestModel } from '@model/customer.model';
import { ValidateAlphanumericWithDash } from '@validator/alphanumeric-with-dash.validator';
import { Title } from "@angular/platform-browser";
import { CountryApiService } from '@services/rest/country-api.service';
import { CountryModel } from '@model/country.model';
import { MsicApiService } from '@services/rest/msic-api.service';
import { MsicModel } from '@model/msic.model';
import { TuneApiService } from '@services/rest/tune-api.service';
import { encode } from '@utils/EncoderHelper';
import { InsuranceDocumentConstant } from '@constants/insurance-documents-constant';

@Component({
  selector: 'app-quotation-policy',
  templateUrl: 'quotation-policy.component.html',
  styleUrls: ['./quotation-policy.component.css'],
  standalone: false,
})


export class QuotationPolicyComponent implements OnInit {
  getProductDisclosureLink ="";
  getPolicyWording ="";
  getTuneProductDisclosureLink ="";
  getTunePolicyWording ="";
  cardWidth = 8;
  current = 0;
  hideDob = false;
  idTextBoxPlaceHolder ="e.g: 801111141111"
  idMask = "000000-00-0000";
  vehicleType ="saloon";
  roadTaxType = ""
  showRoadTaxRunnerService = false;
  showRoadTaxDeliveryService =false;
  roadTaxChecked = true;
  isAllRidersChecked = false;
  isAllRidersDisabled = false;
  isAllDriversChecked = false;
  isAllDriversDisabled = false;
  isLlopChecked = false;
  isSpecialPerilsChecked = false;
  isWindScreenChecked = false;
  isRoadTaxChecked = true;
  isVehicleSumInsuredChanged = false;
  isWindscreenSumInsuredChanged = false;
  isCondition1Checked = false;
  isCondition2Checked = false;
  isCondition3Checked = false;
  isLlopDisabled = false;
  isSpecialPerilsDisabled = false;
  isWindscreenDisabled= false;
  isMobileScreen = false;
  isMakePaymentBtnDisabled = true;
  roadTaxAmount = 0;
  roadTaxDeliveryService = 0;
  roadTaxRunnerService = 0;
  roadTaxServiceCharge = 0;
  totalAmount = 0;
  totalPremium = 0;
  ncdDiscount = 0;
  ncdPerc = 0;
  extraCoveragesAmount = 0;
  grossPremium = 0;
  basicPremium = 0;
  planPremium = 0;
  loading = 0;
  commission = 0;
  stampDuty = 10;
  serviceTax = 0;
  allRiderPremium = 0;
  allDriverPremium = 0;
  llopPremium = 0;
  quotationId = "";
  windScreenPremium = 0;
  specialPerilsPremium = 0;
  selectedInsurance = "";
  policyStartDate = "";
  policyEndDate = "";
  form: UntypedFormGroup;
  engineTypeForm: UntypedFormGroup;
  personalDetailsForm: UntypedFormGroup;
  windScreenform: UntypedFormGroup;
  vehicleform: UntypedFormGroup;
  isSaloonForm: UntypedFormGroup;
  specialRequestForm: UntypedFormGroup;
  submitted = false;
  pdfSubmitted = false;
  quotationRequestModel : QuotationRequestModel={
      dateOfBirth: "",
      extraCoverages : []
    };
  quotationResponseModel: QuotationResponseModel ={};
  calculateRoadTaxRequestModel: CalculateRoadTaxRequestModel ={};
  sumInsuredAmount =0;
  minAgreedValue = 0; 
  maxAgreedValue = 0;
  isZurichLoaded = false;
  isAxaLoaded = false;
  isKurniaLoaded = false;
  isChubbLoaded = false;
  isTuneLoaded = false;
  selectedProductCode = "";
  selectedPlan = "";
  vehicleInfoModel: VehicleInfoModel ={};
  customerInfoModel: CustomerInfoModel ={einvoiceInfo:{}};
  actualPremiumModel: ActualPremiumModel ={};
  agentModel: AgentInfoModel ={};
  paymentResponseModel : PaymentResponseModel = {};
  step1Title = "Enter Details";
  step2Title = "Compare Quotation";
  step3Title = "Add-Ons";
  step4Title = " Details";
  mobileStepTitle = "Step 1: Enter Details";
  idTypeLabel = "Personal"
  verifyVehicleReponseModel : VerifyVehicleReponseModel ={};
  verifyCustomerRequestModel : VerifyCustomerRequestModel ={};
  dropSpecialCharacters = true;
  currentUser: UserModel;
  disablePhysicalRoadTax = false;
  roadTaxSettings: RoadTaxSettings = {};
  commissionSettings: CommissionSettings = {};
  paramQuotationReferenceNumber = "";
  updateSelectedInsuranceModel : UpdateSelectedInsuranceModel ={};
  whatsappRequestModel: WhatsappRequestModel = {};
  updateQuotationSpecialRequestModel: UpdateQuotationSpecialRequestModel = {};
  searchModel:CustomerRequestModel={};
  allDriverTitle = "All Drivers";
  brand: string="";
  model: string="";
  capacity : number;
  chubbPlanName: string = "";
  kurniaPlanName: string = "";
  generaliPlanName: string = "";
  zurichPlanName: string = "";
  isAllRiderCompulsory: boolean = false;
  countryList: CountryModel[] = [];
  msicList: MsicModel[] = [];
  compulsoryOptInForEinvoice = false;
  InsuranceDocumentConstant =InsuranceDocumentConstant;

  constructor( 
      private insuranceApiService: InsuranceApiService,
      private GeneraliApiService: GeneraliApiService,
      private zurichApiService: ZurichApiService,
      private kurniaApiService: KurniaApiService,
      private chubbApiService: ChubbApiService,
      private tuneApiService: TuneApiService,
      private roadTaxApiService: RoadTaxApiService,
      private formBuilder: UntypedFormBuilder,
      private spinner: NgxSpinnerService,
      private recaptchaV3Service: ReCaptchaV3Service,
      private quotationService : QuotationApiService,
      private messageService: NzMessageService,
      private route: ActivatedRoute,
      private quotationApiService: QuotationApiService,
      private router: Router,
      private supportApiService: SupportApiService,
      private customerApiService: CustomerApiService,
      private countryService: CountryApiService,
      private msicService: MsicApiService,
      private titleService: Title
    ) 
  {
  }
  
  disabledEndDate = (endValue: Date): boolean => {
    const now = new Date();
    now.setFullYear(now.getFullYear() - 18);
    return  now.getTime() <= endValue.getTime();
  };

  ngOnInit(): void {
    this.titleService.setTitle("Brilliant Management Service");
    this.checkIsTokenValid();
    var defaultVehicleType = 'Car';  
    this.route.queryParams
    .subscribe(params => { 

      if(params.vehicleType != "" && params.vehicleType != null)
      {
        defaultVehicleType = params.vehicleType;   
        
        if(defaultVehicleType=="car")
          defaultVehicleType= "Car";
        else if(defaultVehicleType=="motorcycle")
          defaultVehicleType= "Motorcycle"
      }

      if(params.quotation != "" && params.quotation != null)
      {
        this.paramQuotationReferenceNumber = params.quotation;   
        this.getExistingQuotation();
      }

    });

    if (window.screen.width <= 412) { // 768px portrait
      this.isMobileScreen = true;
      this.step1Title = "";
      this.step2Title = "";
      this.step3Title = "";
      this.step4Title = "";
    }else{
      this.step1Title = "Enter Details";
      this.step2Title = "Compare Quotation";
      this.step3Title = "Add-Ons";
      this.step4Title = this.idTypeLabel+" Details";
    }

    this.form = this.formBuilder.group({
        bypassIsm:['0'],
        source:['0'],
        type: [defaultVehicleType, [Validators.required]],
        vehicleNo: ['', [Validators.required]],
        idType: ['NRIC', [Validators.required]],
        gender: [''],
        id: ['', [Validators.required]],
        postcode: ['', [Validators.required]],
        contactNo: ['', [Validators.required, Validators.minLength(10)] ],
        email: ['', [Validators.required]],
        nationality: [],
        companyIdType: ['old'],
        dob: [(new Date()).setFullYear((new Date()).getFullYear() - 18)],

    });

    this.engineTypeForm = this.formBuilder.group({
        engineType: [''],
    });

    this.personalDetailsForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required]],
      address1: ['', [Validators.required]],
      address2: ['', [Validators.required]],
      state: ['Selangor', [Validators.required]],
      postcode: [{value:'',disabled:true}, [Validators.required]],
      contactNo1: ['', [Validators.required] ],
      contactNo2: ['' ],
      remark: [''],
      maritalStatus: ['single'],
      tin:[''],
      sstRegNo:[''],
      msicCode:[''],
      compulsoryOptInForEinvoice:['false', [Validators.required]],
    });

    this.windScreenform = this.formBuilder.group({
      windScreenSumInsured: [500,[Validators.min(500),Validators.max(100000)]],
    });

    this.vehicleform = this.formBuilder.group({
      sumInsured: [this.sumInsuredAmount]
    });

    this.isSaloonForm = this.formBuilder.group({
      isSaloon: ["false"],
    });

    this.specialRequestForm = this.formBuilder.group({
      specialRequest: [""],
    });

   bindPostCodeValidator(this.form,'postcode');
   
   this.vehicleform.get('sumInsured').valueChanges
    .pipe(
        debounceTime(1500)
    )
    .subscribe(res => {
      this.onVehicleSumInsuredChanged()
    });

    this.windScreenform.get('windScreenSumInsured').valueChanges
    .pipe(
        debounceTime(1500),
        //distinctUntilChanged()
    )
    .subscribe(res => {
      this.onWindScreenSumInsuredChanged()
    });

  }
  
  getCommissionSettings()
  {
    this.quotationApiService.commissionSettings().subscribe(response => {
      this.commissionSettings = response.entity;
    });
  }

  getRoadTaxSettings()
  {
    this.roadTaxApiService.roadTaxSettings().subscribe(response => {
      this.roadTaxSettings = response.entity;

      this.disablePhysicalRoadTax = this.roadTaxSettings.disableNRICPhysicalRoadTax;
      this.roadTaxDeliveryService = this.roadTaxSettings.deliveryFeeWithInsurance;

      this.calculateRoadTaxCharges();
     
    });
  }

  calculateRoadTaxCharges(){
  
    if(!this.isNricSelected())
    {
      this.roadTaxType = "Physical";
      this.disablePhysicalRoadTax = true;
    }

    if(this.isPhysicalRoadTaxSelected())
    {
      if(!this.roadTaxSettings.runnerFeeWaivedWithInsurance)
        this.roadTaxRunnerService = this.roadTaxSettings.runnerFeeWithInsurance;
      else
        this.roadTaxRunnerService = 0;

      if(!this.roadTaxSettings.deliveryFeeWaivedWithInsurance)
        this.roadTaxDeliveryService = this.roadTaxSettings.deliveryFeeWithInsurance;
      else
        this.roadTaxDeliveryService = 0;

      this.roadTaxType = "Physical"
      this.showRoadTaxRunnerService = true;
      this.showRoadTaxDeliveryService =  true;
    }
    else{
      this.roadTaxType = "Digital";
      this.roadTaxRunnerService = 0;
      this.showRoadTaxRunnerService = false;
      this.showRoadTaxDeliveryService =  false;
    }

    if(!this.roadTaxSettings.serviceChargeWaivedWithInsurance)
      this.roadTaxServiceCharge = this.roadTaxSettings.serviceChargeWithInsurance;
    else
      this.roadTaxServiceCharge = 0;

  }

  checkIsTokenValid()
  {
    this.insuranceApiService
    .ping()
    .subscribe(response => {
        this.currentUser = response.entity;
    });
  }
  
  keyPressAlphaNumeric(event) 
  {
    if(!this.isCompanySelected())
      ValidateAlphanumeric(event);
    else
      ValidateAlphanumericWithDash(event);
  }

  companyIdtypeOnChange(event){
    this.form.patchValue({id:""});
    this.companyIdMaskingChecking(event.target.value );
  }

  companyIdMaskingChecking(value){
    if(value == "old")
    {
      this.idMask ="";
      //this.idMask ="0000000-A||000000-A";
      this.idTextBoxPlaceHolder ="e.g: 1234567-A"
    }
    else{
      this.idMask ="000000000000";
      this.idTextBoxPlaceHolder ="e.g: 202005123456"
    }
  }

  idtypeOnChange(value)
  {
   if(value != "Passport")
   {
    this.hideDob = false;
    this.form.get('dob').setValidators(null);
    this.form.get('dob').updateValueAndValidity();
    this.form.get('nationality').setValidators(null);   
    this.form.get('nationality').updateValueAndValidity();
   }

    if(value == "Passport"){
      this.idTextBoxPlaceHolder ="Enter passport number";
      this.idMask ="";
      this.hideDob = true;
      this.form.get('dob').setValidators(Validators.required);   
      this.form.get('dob').updateValueAndValidity();
      this.form.get('nationality').setValidators(Validators.required);   
      this.form.get('nationality').updateValueAndValidity();
      this.form.get('gender').setValidators(Validators.required);   
      this.form.get('gender').updateValueAndValidity();
      this.dropSpecialCharacters = true;
      this.getCountries();
    }else if(value == "Company"){
      this.dropSpecialCharacters = false;      
      this.companyIdMaskingChecking(this.form.get('companyIdType').value);  

    }else if(value == "Army" || value == "Police"){
      this.idTextBoxPlaceHolder ="Enter uniform professional number"    
      this.dropSpecialCharacters = true;      
      this.idMask ="";
      this.form.get('gender').setValidators(Validators.required);   
      this.form.get('gender').updateValueAndValidity();
    }else if(value == "NRIC"){

      this.idTextBoxPlaceHolder ="e.g: 801111141111"
      this.idMask ="000000-00-0000";
      this.dropSpecialCharacters = true;    
      this.form.get('gender').setValidators(null);   
      this.form.get('gender').updateValueAndValidity();
    }
    
    this.form.patchValue({id:""});  
  }


  onSubmit(moveNextScreen =false, firstLoad = false)
  {
    this.submitted = true;

    if (this.form.invalid || 
      !this.isIdValid() )  
    {   
      this.spinner.hide();   
      return;    
    }

    this.getInstantQuotation(moveNextScreen);
  }

  getInstantQuotation(moveNextScreen)
  {
    this.spinner.show();    
    this.recaptchaV3Service.execute('importantAction')
    .subscribe((token: string) => {

      this.insuranceApiService
      .VerifyToken(token)
      .subscribe(response => {
        
        if(!response){
          this.showNotification("Recaptcha Error",response);      
        }
        else{

          this.verifyCustomerRequestModel.regNo = this.form.get('vehicleNo').value.trim();
          this.verifyCustomerRequestModel.identityType = this.form.get('idType').value.trim();
          this.verifyCustomerRequestModel.identity = this.form.get('id').value.trim();
          this.verifyCustomerRequestModel.postCode = this.form.get('postcode').value.trim();
          this.verifyCustomerRequestModel.email = this.form.get('email').value.trim();
          this.verifyCustomerRequestModel.contactNo = this.form.get('contactNo').value.toString().trim();
          this.verifyCustomerRequestModel.vehicleType = this.isCarSelected() ? 0 : 1;
          this.verifyCustomerRequestModel.state =  getState(parseInt(this.form.get('postcode').value.trim()));
          this.verifyCustomerRequestModel.gender = this.isCompanySelected() ? 'C' : this.form.get('gender').value;
          this.verifyCustomerRequestModel.requestType = "Insurance";
          this.verifyCustomerRequestModel.renewalMonth = 0;
          this.verifyCustomerRequestModel.source =  this.form.get('source').value;
          this.verifyCustomerRequestModel.bypassIsm =  this.form.get('bypassIsm').value == "0" ? false : true;

          if(this.isPassportSelected())
          {
            this.verifyCustomerRequestModel.dateOfBirth = format(this.form.get('dob').value, "yyyy-MM-dd");
            this.verifyCustomerRequestModel.nationality = this.form.get('nationality').value;
          }

          this.insuranceApiService
          .VerifyVehicleInfo( this.verifyCustomerRequestModel)
          .subscribe(response => {
            if(!response.success)
            {
              this.spinner.hide();
              this.showNotification(response.message,response.success);
            }
            else
            {

              if(this.verifyCustomerRequestModel.bypassIsm){
                this.spinner.hide();
                this.showNotification("Quotation Submitted",true);
                return;
              }
              
              this.verifyVehicleReponseModel = response;
              this.ncdPerc = this.verifyVehicleReponseModel.vehicleInfo.ncdPercentage;

              if(this.verifyVehicleReponseModel.existingQuotationFound)
              {
                this.spinner.hide();  
                this.router.navigate(['/'], { queryParams: { quotation: this.verifyVehicleReponseModel.quotationGroupReferenceNumber }});
                this.paramQuotationReferenceNumber = this.verifyVehicleReponseModel.quotationGroupReferenceNumber;   
                return;
              }

              this.quotationRequestModel.customerId = this.verifyVehicleReponseModel.customerId;
              this.quotationRequestModel.customerVehicleId = this.verifyVehicleReponseModel.customerVehicleId;
              this.quotationRequestModel.quotationGroupReferenceNumber = this.verifyVehicleReponseModel.quotationGroupReferenceNumber;
              this.vehicleform.patchValue({suminsured: 0},{emitEvent:false})

              if(this.verifyVehicleReponseModel.vehicleInfo.isMotorcycle)
                this.form.patchValue({type: "Motorcycle"},{emitEvent:false});
              else
                this.form.patchValue({type:"Car"},{emitEvent:false});

              this.vehicleType = this.verifyVehicleReponseModel.vehicleInfo.isSaloon? "saloon" : "nonSaloon";
              if(this.isPassportSelected())
                this.quotationRequestModel.dateOfBirth = format(this.form.get('dob').value, "MM/dd/yyyy");
    
              this.zurichApiService
              .GetQuotation( this.quotationRequestModel)
              .subscribe(response => {
                this.isZurichLoaded =true;
                this.quotationResponseModel.zurich = response.zurich
  
                if(this.quotationResponseModel.zurich?.success )
                  this.quotationRequestModel.referenceNumber = response.zurich.referenceNumber;
          
                if(moveNextScreen)
                  this.checkIsAllInsuranceProcessed(moveNextScreen);
              });
        
              this.GeneraliApiService
              .GetQuotation( this.quotationRequestModel)
              .subscribe(response => {
                this.isAxaLoaded =true;
                this.quotationResponseModel.generali = response.generali

                if(this.quotationResponseModel.generali?.success )
                {
                  this.quotationRequestModel.referenceNumber = response.generali.referenceNumber;
                  this.generaliPlanName = this.quotationResponseModel.generali?.insurancePlan.find(x=>x.code==this.quotationResponseModel.generali?.selectedProductCode).description;
                }
          
                if(moveNextScreen)
                  this.checkIsAllInsuranceProcessed(moveNextScreen);
              });

          
              this.kurniaApiService
              .GetQuotation( this.quotationRequestModel)
              .subscribe(response => {
                this.isKurniaLoaded =true;
                this.quotationResponseModel.kurnia = response.kurnia

                if(this.quotationResponseModel.kurnia?.success )
                {
                  this.quotationRequestModel.referenceNumber = response.kurnia.referenceNumber;
                  this.kurniaPlanName = this.quotationResponseModel.kurnia?.selectedPlan;
                  this.compulsoryOptInForEinvoice =  this.quotationResponseModel.kurnia.einvoiceInfo.compulsoryOptInForEinvoice;
                  this.engineTypeForm.patchValue({engineType: response.kurnia.otherInformation.engineType});
                }
      
                if(moveNextScreen)
                  this.checkIsAllInsuranceProcessed(moveNextScreen);
              });

              this.chubbApiService
              .GetQuotation( this.quotationRequestModel)
              .subscribe(response => {
                this.isChubbLoaded =true;
                this.quotationResponseModel.chubb = response.chubb

                if(this.quotationResponseModel.chubb?.success )         
                {    
                  this.compulsoryOptInForEinvoice =  this.quotationResponseModel.chubb?.einvoiceInfo?.compulsoryOptInForEinvoice;
                  this.quotationRequestModel.referenceNumber = response.chubb.referenceNumber;
                }

  
                if(moveNextScreen)
                  this.checkIsAllInsuranceProcessed(moveNextScreen);
              });

              this.tuneApiService
              .GetQuotation( this.quotationRequestModel)
              .subscribe(response => {
                this.isTuneLoaded =true;
                this.quotationResponseModel.tune = response.tune

                if(this.quotationResponseModel.tune?.success )
                  this.quotationRequestModel.referenceNumber = response.tune.referenceNumber;
  
                if(moveNextScreen)
                  this.checkIsAllInsuranceProcessed(moveNextScreen);
              });
          
       
            }
      
          });
        }
      });
    });
  }

  getExistingQuotation(){
    this.spinner.show();  
 
    this.insuranceApiService
    .GetVehicleInfo( this.paramQuotationReferenceNumber)
    .subscribe(response => {
        this.verifyVehicleReponseModel = response;

        this.quotationApiService
        .getExistingQuotation( this.paramQuotationReferenceNumber)
        .subscribe(response => {
          this.spinner.hide(); 
          if(response.success ){

            this.quotationRequestModel.customerId = this.verifyVehicleReponseModel.customerId;
            this.quotationRequestModel.customerVehicleId = this.verifyVehicleReponseModel.customerVehicleId;
            this.quotationRequestModel.quotationGroupReferenceNumber = this.verifyVehicleReponseModel.quotationGroupReferenceNumber;

            this.quotationResponseModel.generali = response.generali;
            this.quotationResponseModel.chubb = response.chubb;
            this.quotationResponseModel.zurich = response.zurich;
            this.quotationResponseModel.kurnia = response.kurnia; 
            this.quotationResponseModel.tune = response.tune; 
            this.verifyVehicleReponseModel.vehicleInfo = response.vehicleInfo;
            this.ncdPerc = this.verifyVehicleReponseModel.vehicleInfo.ncdPercentage;

            this.form.patchValue({contactNo: response.customerInfo?.contactNo1},{emitEvent:false})
            this.form.patchValue({postcode: response.customerInfo?.postcode },{emitEvent:false})
            this.form.patchValue({email: response.customerInfo?.email },{emitEvent:false})
            this.form.patchValue({vehicleNo : response.vehicleInfo?.registrationNo },{emitEvent:false})
            this.form.patchValue({type : response.vehicleInfo?.vehicleType },{emitEvent:false})
            this.form.patchValue({gender : response.customerInfo?.gender },{emitEvent:false})
            this.engineTypeForm.patchValue({engineType : response.vehicleInfo.engineType },{emitEvent:false})

           
            var identityType = response.customerInfo?.identityType.toString();
            if(identityType == "0")
            {
              this.idtypeOnChange( "NRIC");
              this.form.patchValue({idType: "NRIC"},{emitEvent:false});
            }
            else if(identityType == "1")
            {
              this.idtypeOnChange( "Passport");
              this.form.patchValue({idType: "Passport"},{emitEvent:false});
            }
            else if(identityType == "2")
            {
              this.idtypeOnChange( "Army");
              this.form.patchValue({idType: "Army"},{emitEvent:false});
            }
            else if(identityType == "3")
            {
              this.idtypeOnChange( "Police");   
              this.form.patchValue({idType: "Police"},{emitEvent:false});           
            }
            else if(identityType == "4")
            {
              this.idtypeOnChange( "Company");   
              this.form.patchValue({idType: "Company"},{emitEvent:false});    
            }
            
            this.form.patchValue({id: response.customerInfo?.identity},{emitEvent:false})
            this.calculateRoadTaxCharges();
            this.personalDetailsForm.patchValue({contactNo: response.customerInfo?.contactNo1},{emitEvent:false})
            this.personalDetailsForm.patchValue({postcode: response.customerInfo?.postcode },{emitEvent:false})
            this.personalDetailsForm.patchValue({email: response.customerInfo?.email },{emitEvent:false})
            this.personalDetailsForm.patchValue({id: response.customerInfo?.identity},{emitEvent:false})


            this.generaliPlanName = this.quotationResponseModel.generali?.insurancePlan.find(x=>x.code==this.quotationResponseModel.generali?.selectedProductCode).description;
            this.kurniaPlanName = this.quotationResponseModel.kurnia?.selectedPlan;

            this.current = 1;
            this.changeContent();
            this.calculatePremium();

            if(this.quotationResponseModel.chubb != null)
            {
              this.handleChubbUILogic();
            }
            
          }
          else{
            this.current = 0;
            this.changeContent();
            this.getInstantQuotation(true);
          }
        });                   
      });
  }

  checkIsAllInsuranceProcessed(moveNextScreen){
     if(this.isAxaLoaded && 
      this.isZurichLoaded && 
      this.isKurniaLoaded &&
      this.isChubbLoaded &&
      this.isTuneLoaded)
      {
       this.spinner.hide();     

        if(!this.quotationResponseModel.generali?.success &&
          !this.quotationResponseModel.zurich?.success &&
          !this.quotationResponseModel.kurnia?.success &&
          !this.quotationResponseModel.chubb?.success &&
          !this.quotationResponseModel.tune?.success)
        {
          this.cardWidth = 8;

          this.quotationApiService
          .deleteQuotation( this.verifyVehicleReponseModel.quotationGroupReferenceNumber)
          .subscribe(response => {});

          this.showNotification("No insurance quotation can be found, please contact admin",false);
          this.resetInsuranceLoadedFlag();
        }else{

          if(moveNextScreen)
            this.next(undefined);
        }
      }
  }


  get f(): { [key: string]: AbstractControl; } {
    return this.form.controls;
  }

  get pdf(): { [key: string]: AbstractControl; } {
    return this.personalDetailsForm.controls;
  } 
  
  get wsf(): { [key: string]: AbstractControl; } {
    return this.windScreenform.controls;
  }

  get vf(): { [key: string]: AbstractControl; } {
    return this.vehicleform.controls;
  }

  // get ef(): { [key: string]: AbstractControl; } {
  //   return this.engineTypeForm.controls;
  // }
  
  showNotification(message,status){
    if(status === true){
        this.messageService.success(message); 
    }
    else{
        this.messageService.error(message, {
          nzDuration: 8000});
    }
  }

  pre(): void {
    this.current -= 1;

    if(this.current ==0)
    {
      this.cardWidth = 8;
      this.submitted =false;
      this.quotationResponseModel = {};
      this.isZurichLoaded = false;
      this.isAxaLoaded = false;
      this.isKurniaLoaded = false;
      this.mobileStepTitle = "Step 1: Enter Details"
      this.router.navigate([], { queryParams: {} });
      this.resetValueStep0();
    }
    else if(this.current == 1){
      this.cardWidth = 12;
      this.mobileStepTitle = "Step 2: Compare Quotation"
      this.resetValueStep1();
    }
    else if(this.current == 2){
      this.mobileStepTitle = "Step 3: Add-Ons"
      this.cardWidth = 10;
    }
    else if(this.current == 3){
      this.mobileStepTitle = "Step 4: "+this.idTypeLabel+" Details"
      this.cardWidth = 8;
    }
  }

  next(insurance): void {

    if(insurance!=undefined)     
    {
      this.selectedInsurance =  insurance ;    

      if(this.isChubbSelected()) 
      {        
          this.getProductDisclosureLink = "https://bmsroadtax.com/wp-content/uploads/2024/04/my-car-insurance_eng_v6.pdf";
          this.getPolicyWording = "https://bmsroadtax.com/wp-content/uploads/2024/05/chubb-my-car-insurance-PW.pdf";
          this.selectedProductCode = this.quotationResponseModel.chubb?.selectedProductCode;
          this.personalDetailsForm.patchValue({tin : this.quotationResponseModel.chubb?.einvoiceInfo?.tin },{emitEvent:false})

          if(this.quotationResponseModel.chubb?.einvoiceInfo?.compulsoryOptInForEinvoice == undefined ||
            this.quotationResponseModel.chubb?.einvoiceInfo?.compulsoryOptInForEinvoice == false)
            {
               this.compulsoryOptInForEinvoice = false;
            }
            else{
                  this.compulsoryOptInForEinvoice = true;
            }
      }      
      else if(this.isGeneraliSelected())
      {
        if(this.isCarSelected())
          this.getProductDisclosureLink = "https://asset.bmsroadtax.com/product-disclosure/generali-car.pdf";      
        else
          this.getProductDisclosureLink = "https://asset.bmsroadtax.com/product-disclosure/generali-motor.pdf";

        this.selectedProductCode = this.quotationResponseModel.generali?.selectedProductCode;
      }      
      else if(this.isZurichSelected()) 
      {
        if(this.isCarSelected())
        {
          this.getProductDisclosureLink = "https://www.zurich.com.my/-/media/project/zwp/malaysia/docs/insurance-products/product-disclosure-sheets/zgimb-z-driver-pds_eng.pdf";      
          this.getPolicyWording = "https://www.zurich.com.my/-/media/project/zwp/malaysia/docs/insurance-products/policy-wordings/zgimb-z-driver-cw_eng.pdf";
        }
        else
        {
          this.getProductDisclosureLink = "https://www.zurich.com.my/-/media/project/zwp/malaysia/docs/insurance-products/product-disclosure-sheets/zgimb_z-rider_pds_eng.pdf";
          this.getPolicyWording = "https://www.zurich.com.my/-/media/project/zwp/malaysia/docs/insurance-products/policy-wordings/zgimb-z-rider-pw-eng.pdf";
        }

        this.selectedProductCode = this.quotationResponseModel.zurich?.selectedProductCode;
      }
      else if(this.isKurniaSelected()) 
      {
        if(this.isCarSelected())
        {
          this.getProductDisclosureLink = "https://www.kurnia.com/sites/asia-kurnia/files/2018-05/Private%20Car%20-Product%20Disclosure%20Sheet%20%28Eng%29.pdf";      
          this.getPolicyWording = "https://www.kurnia.com/sites/asia-kurnia/files/2017-10/Private%20Car%20Policy%20Wording%20before%2021%20Oct%202016%20%28ENG%29_1.pdf";
        }
        else
        {
            this.getProductDisclosureLink = "https://www.kurnia.com/sites/asia-kurnia/files/2018-05/Motorcycle%20-%20Product%20Disclosure%20Sheet%20%28Eng%29.pdf";
            this.getPolicyWording = "https://www.kurnia.com/sites/asia-kurnia/files/2017-10/Motorcycle%20Policy%20Wording%20before%2021%20Oct%20%28ENG%29_1.pdf";
        }

          this.selectedProductCode = this.quotationResponseModel.kurnia?.selectedProductCode;
          this.personalDetailsForm.patchValue({tin : this.quotationResponseModel.kurnia.einvoiceInfo?.sstRegNo },{emitEvent:false})

           if(this.quotationResponseModel.kurnia.einvoiceInfo?.compulsoryOptInForEinvoice == undefined ||
            this.quotationResponseModel.kurnia.einvoiceInfo?.compulsoryOptInForEinvoice == false)
            {
               this.compulsoryOptInForEinvoice = false;
            }
            else{
                  this.compulsoryOptInForEinvoice = true;
            }

      }
      else if(this.isTuneSelected()) 
      {
        if(this.isCarSelected())
        {
          this.getProductDisclosureLink = InsuranceDocumentConstant.Tune_Car_PDS;      
          this.getPolicyWording = InsuranceDocumentConstant.Tune_Car_PW;
        }
        else
        {
            this.getProductDisclosureLink = InsuranceDocumentConstant.Tune_Bike_PDS;    
            this.getPolicyWording = InsuranceDocumentConstant.Tune_Bike_PW;    
        }

          this.selectedProductCode = this.quotationResponseModel.tune?.selectedProductCode;
      }

      if(this.isGeneraliSelected())
        this.allDriverTitle="Multi Drive Bravo"
      else
        this.allDriverTitle="All Drivers"
      }



    // if(this.isMotorcycleThirdPartyProductSelected() &&
    //   this.displaySumInsured() &&
    //   this.current == 2 
    // )
    // {
    //   this.motorSumInsuredConfirmationPopUp();
    // }
    // else
    // {
      this.current += 1; 
    //}

    this.changeContent();
  }

  changeContent(): void {
    switch (this.current) {
      case 0: {
        this.router.navigate([], { queryParams: {} });
        this.checkIsTokenValid();
        this.cardWidth = 8;
        this.mobileStepTitle = "Step 1: Enter Details"
        break;
      }
      case 1: {
        this.checkIsTokenValid();
        this.getRoadTaxSettings();
        this.cardWidth = 12;
        this.mobileStepTitle = "Step 2: Compare Quotation"
        this.getTunePolicyWordingAndPds();
        break;
      }
      case 2: {
        this.cardWidth = 10;
        this.mobileStepTitle = "Step 3: Add-Ons"        

        this.getCommissionSettings();
        this.checkIsTokenValid();
        this.onVehicleTypeClick("saloon");                
        this.updateSelectedInsurance(this.getSelectedInsuranceReferenceNumber());
        this.displayAllDrivers();
        this.displaySumInsured();
        this.getAllDriverPremium();
        this.getAllRiderPremium();
        this.getMsicCode();
        break;
      }
      case 3: {
        this.checkIsTokenValid();

        this.cardWidth = 8;
        this.idTypeLabel = this.isCompanySelected() ? "Company" : "Personal";
        this.mobileStepTitle = "Step 4: "+this.idTypeLabel+" Details"
        this.personalDetailsForm.patchValue({contactNo1: this.form.get('contactNo').value.trim()})
        this.personalDetailsForm.patchValue({postcode: this.form.get('postcode').value.trim()})
        this.personalDetailsForm.patchValue({email: this.form.get('email').value.trim()})
        this.personalDetailsForm.patchValue({state: getState(parseInt(this.form.get('postcode').value.trim()))})
  
        if(!this.isCompanySelected())
        {

          if(this.compulsoryOptInForEinvoice){
            this.personalDetailsForm.get('tin').setValidators(Validators.required);   
            this.personalDetailsForm.get('tin').updateValueAndValidity();         
          }
          else{
            this.personalDetailsForm.get('tin').setValidators(null);   
            this.personalDetailsForm.get('tin').updateValueAndValidity();         
          }
    
        }else if(this.isCompanySelected()){
          this.personalDetailsForm.get('tin').setValidators(Validators.required);   
          this.personalDetailsForm.get('tin').updateValueAndValidity();
        }
        break;
      }
      default: {
      }
    }
  }

  // confirmationModel: BsModalRef;
  // motorSumInsuredConfirmationPopUp(){
  //   this.confirmationModel = this.bsModalService.show(
  //     ConfirmationModalComponent,
  //     {
  //         class: 'modal-md',
  //         ignoreBackdropClick: true,
  //         initialState: {
  //           content: "Please confirm your Motorcycle sum insured (RM"+this.vehicleform.get("sumInsured").value.toLocaleString('en-GB')+") is enough?"
  //         },
  //     }
  //   );

  //   this.confirmationModel.content.submitEvent.subscribe(() => {
  //     this.current += 1; 
  //     this.changeContent();
  //   });
  // }

  onRoadTaxChecked(value){
    this.isRoadTaxChecked = value;

    if(this.isRoadTaxChecked)
    {
      this.roadTaxDeliveryService = 0;

      if(this.isCompanySelected() ||
        this.isPassportSelected() )
        this.roadTaxRunnerService = 20;

      this.calculateRoadTax();
    }
    else
    {
      this.calculatePremium();
    }
  }

  onAllDriversChecked(value){
    this.isAllDriversChecked = value;

    if(!value){
      this.quotationRequestModel.extraCoverages = this.quotationRequestModel.extraCoverages.filter(x => x.coverageName !== CoveragesConstant.ALL_DRIVERS);
    }else{
      if(!this.quotationRequestModel.extraCoverages.some(x=>x.coverageName ==CoveragesConstant.ALL_DRIVERS))    
        this.quotationRequestModel.extraCoverages.push({ coverageName :CoveragesConstant.ALL_DRIVERS, coverageAmount : 0});
    }

    if(this.isGeneraliSelected())
      this.reCalculateGeneraliAdditionalCoveragePremium();
    else if(this.isChubbSelected())
      this.reCalculateChubbAdditionalCoveragePremium();    
    else if(this.isTuneSelected())
      this.reCalculateTuneAdditionalCoveragePremium();           
    else
      this.calculatePremium();
  }

  
  onAllRidersChecked(value){
    this.isAllRidersChecked = value;

    if(!value){
      this.quotationRequestModel.extraCoverages = this.quotationRequestModel.extraCoverages.filter(x => x.coverageName !== CoveragesConstant.ALL_RIDERS);
    }else{
      if(!this.quotationRequestModel.extraCoverages.some(x=>x.coverageName ==CoveragesConstant.ALL_RIDERS))    
        this.quotationRequestModel.extraCoverages.push({ coverageName :CoveragesConstant.ALL_RIDERS, coverageAmount : 0});
    }

    if(this.isZurichSelected())
      this.reCalculateZurichAdditionalCoveragePremium();     
    else if (this.isKurniaSelected())
      this.reCalculateKurniaAdditionalCoveragePremium();   
    else if (this.isGeneraliSelected())
      this.reCalculateGeneraliAdditionalCoveragePremium();   
    else if (this.isTuneSelected())
      this.reCalculateTuneAdditionalCoveragePremium();   
  }

  onLlopChecked(value){
    this.isLlopChecked = value;


    if(!this.isLlopChecked){
      this.quotationRequestModel.extraCoverages = this.quotationRequestModel.extraCoverages.filter(x => x.coverageName !== CoveragesConstant.LLOP);
    }
    else{
      if(!this.quotationRequestModel.extraCoverages.some(x=>x.coverageName ==CoveragesConstant.LLOP))    
        this.quotationRequestModel.extraCoverages.push({ coverageName :CoveragesConstant.LLOP, coverageAmount : 0});
    }

    if(this.isGeneraliSelected())
      this.reCalculateGeneraliAdditionalCoveragePremium()      
    else if(this.isChubbSelected())
      this.reCalculateChubbAdditionalCoveragePremium();
    else if(this.isKurniaSelected())
      this.reCalculateKurniaAdditionalCoveragePremium();
    else if(this.isZurichSelected())
      this.reCalculateZurichAdditionalCoveragePremium();
    else if(this.isTuneSelected())
      this.reCalculateTuneAdditionalCoveragePremium();
  }

  onWindScreenChecked(value)
  {
    this.isWindScreenChecked = value;

    if(!value){
      this.windScreenPremium = 0;
      this.quotationRequestModel.extraCoverages = this.quotationRequestModel.extraCoverages.filter(x => x.coverageName !== CoveragesConstant.WINDSCREEN);
      this.windScreenform.get('windScreenSumInsured').setValidators(null);   
      this.windScreenform.get('windScreenSumInsured').updateValueAndValidity();

    }else{
      this.windScreenform.get('windScreenSumInsured').setValidators([Validators.required,Validators.min(1)]);   
      this.windScreenform.get('windScreenSumInsured').updateValueAndValidity();
      
      this.addWindScreenCoverage();
    }

    if(this.isGeneraliSelected())
      this.reCalculateGeneraliAdditionalCoveragePremium();      
    else if(this.isTuneSelected())
      this.reCalculateTuneAdditionalCoveragePremium();   
    else
      this.onWindScreenSumInsuredChanged();    
  }

  onWindScreenSumInsuredChanged()
  {

    if( this.windScreenform.get('windScreenSumInsured').value >= 500 && 
        this.windScreenform.get('windScreenSumInsured').value <= 100000 &&
        this.isWindScreenChecked
        )
    {

      this.addWindScreenCoverage();

      if(this.isChubbSelected())
        this.reCalculateChubbAdditionalCoveragePremium();
      else if(this.isZurichSelected())
        this.reCalculateZurichAdditionalCoveragePremium();
      else
        this.windScreenPremium = this.windScreenform.get('windScreenSumInsured').value * 0.15;

      this.calculatePremium();
    }
    this.isWindscreenSumInsuredChanged = false;
  }

  addWindScreenCoverage(){
    if(!this.quotationRequestModel.extraCoverages.some(x=>x.coverageName ==CoveragesConstant.WINDSCREEN))    
    {
      this.quotationRequestModel.extraCoverages.push({ coverageName :CoveragesConstant.WINDSCREEN, coverageAmount : this.windScreenform.get('windScreenSumInsured').value});
    }
    else{
      this.quotationRequestModel.extraCoverages = this.quotationRequestModel.extraCoverages.filter(x => x.coverageName !== CoveragesConstant.WINDSCREEN);
      this.quotationRequestModel.extraCoverages.push({ coverageName :CoveragesConstant.WINDSCREEN, coverageAmount : this.windScreenform.get('windScreenSumInsured').value});
    }
  }

  onVehicleSumInsuredChanged(){
    var sumInsured = this.vehicleform.get('sumInsured').value ;
    this.quotationRequestModel.sumInsured =sumInsured;    

 
    if(sumInsured >= this.minAgreedValue && 
      sumInsured <= this.maxAgreedValue && 
      !this.isVehicleSumInsuredChanged)
    {

      setTimeout(()=>{           
        if(this.isZurichSelected())
          this.reCalculateZurichAdditionalCoveragePremium();    
        else if(this.isKurniaSelected())
          this.reCalculateKurniaAdditionalCoveragePremium()               
        else if(this.isGeneraliSelected())
          this.reCalculateGeneraliAdditionalCoveragePremium()       
        else if(this.isChubbSelected())
          this.reCalculateChubbSumInsuredPremium();
        }, 2000);
    }
    this.isVehicleSumInsuredChanged = false;
  }

  reCalculateChubbSumInsuredPremium()
  {
    this.spinner.show();
    this.quotationRequestModel.referenceNumber = this.quotationResponseModel.chubb.referenceNumber;

    this.chubbApiService
          .GetQuotation( this.quotationRequestModel)
          .subscribe(response => {
            this.quotationResponseModel.chubb = response.chubb
            this.calculatePremium();
            this.spinner.hide();
          });  
  }

  onSpecialPerilsChecked(value, triggerSubmit = false){
    this.isSpecialPerilsChecked = value;
    if(!value){
      this.specialPerilsPremium = 0;
      this.quotationRequestModel.extraCoverages = this.quotationRequestModel.extraCoverages.filter(x => x.coverageName !== CoveragesConstant.SPECIAL_PERILS);
      
    }else{
      if(!this.quotationRequestModel.extraCoverages.some(x=>x.coverageName ==CoveragesConstant.SPECIAL_PERILS))    
        this.quotationRequestModel.extraCoverages.push({ coverageName :CoveragesConstant.SPECIAL_PERILS, coverageAmount : 0});
    }

    if(triggerSubmit)
    {
      if(this.isZurichSelected())
        this.reCalculateZurichAdditionalCoveragePremium();
      else if(this.isKurniaSelected())
        this.reCalculateKurniaAdditionalCoveragePremium();
      else if(this.isChubbSelected())        
        this.reCalculateChubbAdditionalCoveragePremium();
      else if(this.isGeneraliSelected())        
        this.reCalculateGeneraliAdditionalCoveragePremium();
      else if(this.isTuneSelected())        
        this.reCalculateTuneAdditionalCoveragePremium();
    }
  }
  
  calculateRoadTax(){
    this.calculateRoadTaxRequestModel.isIndividual = !this.isCompanySelected();
    this.calculateRoadTaxRequestModel.isSaloon =  !this.verifyVehicleReponseModel.vehicleInfo.isWagon ? 
                                                  this.verifyVehicleReponseModel.vehicleInfo.isSaloon : 
                                                  (this.isSaloonForm.get('isSaloon').value == "false" ? false : true);

    this.calculateRoadTaxRequestModel.vehicleType = this.isCarSelected() ? 0 : 1;
    this.calculateRoadTaxRequestModel.vehicleType = this.verifyVehicleReponseModel.vehicleInfo.vehicleType == 'Motorcycle' ? 1 : 0;

    
    if(this.verifyVehicleReponseModel.vehicleInfo!=null)
      this.calculateRoadTaxRequestModel.capacity = this.verifyVehicleReponseModel.vehicleInfo.capacity;

    this.roadTaxApiService
    .CalculateRoadTax( this.calculateRoadTaxRequestModel)
    .subscribe(response => {
        this.roadTaxAmount = response ;
      this.calculatePremium();       
    });
  }

  calculatePremium()
  {
    this.capacity = this.verifyVehicleReponseModel.vehicleInfo.capacity;
    this.brand = this.verifyVehicleReponseModel.vehicleInfo.brand;
    this.model = this.verifyVehicleReponseModel.vehicleInfo.model;

    if(this.selectedInsurance ==InsuranceCompanyConstant.ZURICH)
    {

      this.basicPremium = this.quotationResponseModel.zurich?.suggestedPremium.basicPremium;
      this.planPremium = 0;
      this.loading = this.quotationResponseModel.zurich?.suggestedPremium.loading;
      this.minAgreedValue = this.quotationResponseModel.zurich?.vehicleValueInfo.minAgreedValue;
      this.maxAgreedValue = this.quotationResponseModel.zurich?.vehicleValueInfo.maxAgreedValue;
      this.sumInsuredAmount = this.quotationResponseModel.zurich?.suggestedPremium.sumInsured;
      this.ncdDiscount = this.quotationResponseModel.zurich?.suggestedPremium.ncdAmount;    
  
      this.quotationId = this.quotationResponseModel.zurich?.policy?.insuranceCompanyQuotationId;    
      this.policyStartDate = this.quotationResponseModel.zurich?.policy?.policyStartDate;
      this.policyEndDate = this.quotationResponseModel.zurich?.policy?.policyEndDate;    
      this.selectedProductCode =  this.quotationResponseModel.zurich?.selectedProductCode;
      this.selectedPlan = this.quotationResponseModel.zurich?.selectedPlan;
      this.quotationRequestModel.productCode =      this.selectedProductCode;
    }
    else if(this.selectedInsurance ==InsuranceCompanyConstant.GENERALI)
    {
      this.basicPremium = this.quotationResponseModel.generali?.suggestedPremium.basicPremium;
      this.planPremium = 0;
      this.minAgreedValue = this.quotationResponseModel.generali?.vehicleValueInfo.minAgreedValue;
      this.maxAgreedValue = this.quotationResponseModel.generali?.vehicleValueInfo.maxAgreedValue;
      this.sumInsuredAmount = this.quotationResponseModel.generali?.suggestedPremium.sumInsured;
      this.ncdDiscount = this.quotationResponseModel.generali?.suggestedPremium.ncdAmount;
      this.quotationId = this.quotationResponseModel.generali?.policy?.insuranceCompanyQuotationId;    
      this.policyStartDate = this.quotationResponseModel.generali?.policy?.policyStartDate;
      this.policyEndDate = this.quotationResponseModel.generali?.policy?.policyEndDate;
      this.selectedProductCode =  this.quotationResponseModel.generali?.selectedProductCode;
      this.selectedPlan = this.quotationResponseModel.generali?.selectedPlan;
      this.quotationRequestModel.productCode =      this.selectedProductCode;
    }
    else if(this.selectedInsurance == InsuranceCompanyConstant.KURNIA)
    {
      this.basicPremium = this.quotationResponseModel.kurnia?.suggestedPremium.basicPremium;
      this.planPremium = 0;
      this.loading = this.quotationResponseModel.kurnia?.suggestedPremium.loading;
      this.minAgreedValue = this.quotationResponseModel.kurnia?.vehicleValueInfo.minAgreedValue;
      this.maxAgreedValue = this.quotationResponseModel.kurnia?.vehicleValueInfo.maxAgreedValue;
      this.sumInsuredAmount = this.quotationResponseModel.kurnia?.suggestedPremium.sumInsured;
      this.ncdDiscount = this.quotationResponseModel.kurnia?.suggestedPremium.ncdAmount;
      this.quotationId = this.quotationResponseModel.kurnia?.policy?.insuranceCompanyQuotationId;   

      this.policyStartDate = this.quotationResponseModel.kurnia?.policy?.policyStartDate;
      this.policyEndDate = this.quotationResponseModel.kurnia?.policy?.policyEndDate;
      this.selectedProductCode =  this.quotationResponseModel.kurnia?.selectedProductCode;
      this.selectedPlan = this.quotationResponseModel.kurnia?.selectedPlan;
      this.quotationRequestModel.productCode =      this.selectedProductCode;
    }
    else if(this.selectedInsurance ==InsuranceCompanyConstant.CHUBB)
    {
      this.basicPremium = this.quotationResponseModel.chubb?.suggestedPremium.basicPremium;
      this.planPremium = this.quotationResponseModel.chubb?.suggestedPremium.planPremium;
      this.minAgreedValue = this.quotationResponseModel.chubb?.vehicleValueInfo.minAgreedValue;
      this.maxAgreedValue = this.quotationResponseModel.chubb?.vehicleValueInfo.maxAgreedValue;
      this.sumInsuredAmount = this.quotationResponseModel.chubb?.suggestedPremium.sumInsured;
      this.ncdDiscount = this.quotationResponseModel.chubb?.suggestedPremium.ncdAmount;
      this.quotationId = this.quotationResponseModel.chubb?.policy?.insuranceCompanyQuotationId;   
      this.policyStartDate = this.quotationResponseModel.chubb?.policy?.policyStartDate;
      this.policyEndDate = this.quotationResponseModel.chubb?.policy?.policyEndDate;
      this.selectedProductCode =  this.quotationResponseModel.chubb?.selectedProductCode;
      this.selectedPlan = this.quotationResponseModel.chubb?.selectedPlan;
      this.quotationRequestModel.productCode =      this.selectedProductCode;
    }
    else if(this.selectedInsurance ==InsuranceCompanyConstant.TUNE)
    {

      this.basicPremium = this.quotationResponseModel.tune?.suggestedPremium.basicPremium;
      this.planPremium = 0;
      this.minAgreedValue = this.quotationResponseModel.tune?.vehicleValueInfo.minAgreedValue;
      this.maxAgreedValue = this.quotationResponseModel.tune?.vehicleValueInfo.maxAgreedValue;
      this.sumInsuredAmount = this.quotationResponseModel.tune?.suggestedPremium.sumInsured;
      this.ncdDiscount = this.quotationResponseModel.tune?.suggestedPremium.ncdAmount;
      this.quotationId = this.quotationResponseModel.tune?.policy?.insuranceCompanyQuotationId;   
      this.policyStartDate = this.quotationResponseModel.tune?.policy?.policyStartDate;
      this.policyEndDate = this.quotationResponseModel.tune?.policy?.policyEndDate;
      this.selectedProductCode =  this.quotationResponseModel.tune?.selectedProductCode;
      this.selectedPlan = this.quotationResponseModel.tune?.selectedPlan;
      this.quotationRequestModel.productCode =      this.selectedProductCode;
    }


    var actualAllDriverPremium =  this.allDriverPremium;
    if(!this.isAllDriversChecked)
      actualAllDriverPremium = 0;

    var actualLlopPremium =  this.llopPremium;
    if(!this.isLlopChecked)
        actualLlopPremium = 0;

    var actualWindScreenPremium =  this.windScreenPremium;
    if(!this.isWindScreenChecked)
      actualWindScreenPremium = 0;

    var actualRoadTaxDeliveryService =  this.getRoadTaxDeliveryService();
    var actualRoadTaxAmount =  this.getRoadTaxAmount();
    var actualRoadTaxRunnerService = this.getRoadTaxRunnerService();
    var actualRoadTaxServiceCharge = this. getRoadTaxServiceCharge()

    this.extraCoveragesAmount = actualLlopPremium + actualAllDriverPremium + this.specialPerilsPremium + 
                            this.allRiderPremium + actualWindScreenPremium ;
  
    this.grossPremium = Math.round((this.basicPremium +this.planPremium + this.loading - this.ncdDiscount + this.extraCoveragesAmount + Number.EPSILON) * 100) / 100;
    this.commission =  Math.round((this.grossPremium * 0.1 + Number.EPSILON) * 100) / 100;
    this.serviceTax = Math.round((this.grossPremium * 0.08 + Number.EPSILON) * 100) / 100;

    this.totalPremium =  this.grossPremium +  this.serviceTax  + this.stampDuty ;
    this.totalAmount = this.grossPremium +  this.serviceTax + actualRoadTaxAmount + this.stampDuty + actualRoadTaxServiceCharge
                        + actualRoadTaxRunnerService  + actualRoadTaxDeliveryService;
 
    this.isVehicleSumInsuredChanged = true;
    this.isWindscreenSumInsuredChanged = true;
    this.vehicleform.get('sumInsured').setValue(this.sumInsuredAmount,{ emitEvent: false  });
    this.vehicleform.get('sumInsured').setValidators([Validators.required,Validators.min(this.minAgreedValue),Validators.max(this.maxAgreedValue)]);   
    this.vehicleform.get('sumInsured').updateValueAndValidity();
  }

  getRoadTaxAmount()
  {
    var actualRoadTaxAmount =  this.roadTaxAmount;

    if(!this.isRoadTaxChecked)
        actualRoadTaxAmount = 0;

    return actualRoadTaxAmount;
  }

  getRoadTaxRunnerService()
  {
    var actualRoadTaxRunnerService = this.roadTaxRunnerService
    if(!this.isRoadTaxChecked)
        actualRoadTaxRunnerService = 0;

    if(this.roadTaxSettings.runnerFeeWaivedWithInsurance)
      actualRoadTaxRunnerService = 0;

    return actualRoadTaxRunnerService;
  }

  getRoadTaxServiceCharge()
  {
    var actualRoadTaxServiceCharge = this.roadTaxServiceCharge

    if(!this.isRoadTaxChecked)
        actualRoadTaxServiceCharge = 0;

    if(this.roadTaxSettings.serviceChargeWaivedWithInsurance)
      actualRoadTaxServiceCharge = 0;

    return actualRoadTaxServiceCharge;
  }

  getRoadTaxDeliveryService()
  {
    var actualRoadTaxDeliveryService = this.roadTaxDeliveryService

    if(!this.isRoadTaxChecked)
      actualRoadTaxDeliveryService = 0;

    if(this.isDigitalRoadTaxSelected()){
      actualRoadTaxDeliveryService = 0;
    }else{
      if(this.roadTaxSettings.deliveryFeeWaivedWithInsurance)
        actualRoadTaxDeliveryService = 0;
    }

    return actualRoadTaxDeliveryService;
  }

  getAllDriverPremium(){

    if(!this.isCarSelected())
      return;
  
    //clear value
    this.allDriverPremium = 0;
    this.isAllDriversChecked = false;
    this.isAllDriversDisabled = false;

    if(this.selectedInsurance ==InsuranceCompanyConstant.ZURICH)
    {
      if(this.isCompanySelected())
      {
        this.isAllDriversChecked = true;
        this.isAllDriversDisabled = true;
        this.allDriverPremium = 30;
      }
      else
        this.allDriverPremium = 20;
    }
    else if(this.selectedInsurance ==InsuranceCompanyConstant.KURNIA)
    {
     
      if(this.isCompanySelected() && 
        (this.selectedProductCode == "COMP" || 
          this.selectedProductCode == "COMP PLUS" ||
          this.selectedProductCode == "COMP PREM"))
      {
          this.allDriverPremium = 50; 
      }

      this.isAllDriversChecked = true;
      this.isAllDriversDisabled = true;
    }
    else if(this.selectedInsurance ==InsuranceCompanyConstant.CHUBB)
    {
      if(this.isCompanySelected())
      {
        this.isAllDriversChecked = true;
        this.isAllDriversDisabled = true;
        this.allDriverPremium = this.quotationResponseModel.chubb.suggestedPremium.allDrivers;
      }
    }
    else if(this.selectedInsurance ==InsuranceCompanyConstant.GENERALI)
    {
      if(this.isCompanySelected())
      {
        this.isAllDriversChecked = true;
        this.isAllDriversDisabled = true;
      }
    }

  }

  getAllRiderPremium(){

    if(!this.isMotorcycleSelected())
      return;

    this.allRiderPremium = 0;
    this.isAllRidersChecked = false;
    this.isAllRidersDisabled = false;
    this.isAllRiderCompulsory =  false;

    if(this.isZurichSelected())
    {
      if(this.quotationResponseModel.zurich.suggestedPremium.allRiderAmt > 0)
      {
          this.allRiderPremium = this.quotationResponseModel.zurich.suggestedPremium.allRiderAmt;
          this.isAllRidersChecked = true;
          this.isAllRidersDisabled = true;
          this.isAllRiderCompulsory =  true;
      }
    }
    else if(this.isKurniaSelected())
    {
      if(this.quotationResponseModel.kurnia.suggestedPremium.allRiderAmt > 0)
      {
          this.allRiderPremium = this.quotationResponseModel.kurnia.suggestedPremium.allRiderAmt;
          this.isAllRidersChecked = true;
          this.isAllRidersDisabled = true;
          this.isAllRiderCompulsory =  true;
      }
    }
  }

  reCalculateGeneraliAdditionalCoveragePremium(){
    this.spinner.show();

    this.quotationRequestModel.referenceNumber = this.quotationResponseModel.generali.referenceNumber;
    this.quotationRequestModel.productCode = this.selectedProductCode;
    
    this.GeneraliApiService
    .GetQuotation( this.quotationRequestModel)
    .subscribe(response => {
      this.quotationResponseModel.generali = response.generali
      
      if(this.quotationResponseModel.generali.extraCoverages?.some(x=>x.coverageName == CoveragesConstant.SPECIAL_PERILS))
        this.specialPerilsPremium  = this.quotationResponseModel.generali.extraCoverages?.find(x=>x.coverageName==CoveragesConstant.SPECIAL_PERILS)?.coveragePremium;

      if(this.quotationResponseModel.generali.extraCoverages?.some(x=>x.coverageName == CoveragesConstant.ALL_DRIVERS))
        this.allDriverPremium  = this.quotationResponseModel.generali.extraCoverages?.find(x=>x.coverageName==CoveragesConstant.ALL_DRIVERS)?.coveragePremium;

      if(this.quotationResponseModel.generali.extraCoverages?.some(x=>x.coverageName == CoveragesConstant.ALL_RIDERS))
        this.allRiderPremium  = this.quotationResponseModel.generali.extraCoverages?.find(x=>x.coverageName==CoveragesConstant.ALL_RIDERS)?.coveragePremium;

      if(this.quotationResponseModel.generali.extraCoverages?.some(x=>x.coverageName == CoveragesConstant.WINDSCREEN))
        this.windScreenPremium  = this.quotationResponseModel.generali.extraCoverages?.find(x=>x.coverageName==CoveragesConstant.WINDSCREEN)?.coveragePremium;

      this.calculatePremium();
      this.spinner.hide();
    });
  }

  reCalculateZurichAdditionalCoveragePremium(){
    this.spinner.show();

    this.quotationRequestModel.referenceNumber = this.quotationResponseModel.zurich.referenceNumber;

    this.zurichApiService
    .GetQuotation( this.quotationRequestModel)
    .subscribe(response => {
      
      this.quotationResponseModel.zurich = response.zurich;

      if(this.quotationResponseModel.zurich.extraCoverages.some(x=>x.coverageName == CoveragesConstant.ALL_DRIVERS))
        this.allDriverPremium  =  this.quotationResponseModel.zurich?.extraCoverages.find(x=>x.coverageName == CoveragesConstant.ALL_DRIVERS)?.coveragePremium;

      if(this.quotationResponseModel.zurich.extraCoverages?.some(x=>x.coverageName == CoveragesConstant.WINDSCREEN))
        this.windScreenPremium = this.quotationResponseModel.zurich?.extraCoverages.find(x=>x.coverageName == CoveragesConstant.WINDSCREEN)?.coveragePremium;

      if(this.quotationResponseModel.zurich.extraCoverages?.some(x=>x.coverageName == CoveragesConstant.SPECIAL_PERILS))
        this.specialPerilsPremium = this.quotationResponseModel.zurich?.extraCoverages.find(x=>x.coverageName == CoveragesConstant.SPECIAL_PERILS)?.coveragePremium;   

      if(this.quotationResponseModel.zurich.extraCoverages?.some(x=>x.coverageName == CoveragesConstant.LLOP))
        this.llopPremium = this.quotationResponseModel.zurich?.extraCoverages.find(x=>x.coverageName == CoveragesConstant.LLOP)?.coveragePremium;   

      this.calculatePremium();
      this.spinner.hide();
    });
  }

  reCalculateKurniaAdditionalCoveragePremium(){
    this.spinner.show()

    this.quotationRequestModel.referenceNumber = this.quotationResponseModel.kurnia.referenceNumber;

    this.kurniaApiService
    .GetQuotation( this.quotationRequestModel)
    .subscribe(response => {
      
      this.quotationResponseModel.kurnia = response.kurnia;

      if(this.quotationResponseModel.kurnia.extraCoverages.some(x=>x.coverageName == CoveragesConstant.ALL_DRIVERS))
        this.allDriverPremium  =  this.quotationResponseModel.kurnia?.extraCoverages.find(x=>x.coverageName == CoveragesConstant.ALL_DRIVERS)?.coveragePremium;

      if(this.quotationResponseModel.kurnia.extraCoverages?.some(x=>x.coverageName == CoveragesConstant.WINDSCREEN))
        this.windScreenPremium = this.quotationResponseModel.kurnia?.extraCoverages.find(x=>x.coverageName == CoveragesConstant.WINDSCREEN)?.coveragePremium;

      if(this.quotationResponseModel.kurnia.extraCoverages?.some(x=>x.coverageName == CoveragesConstant.SPECIAL_PERILS))
        this.specialPerilsPremium = this.quotationResponseModel.kurnia?.extraCoverages.find(x=>x.coverageName == CoveragesConstant.SPECIAL_PERILS)?.coveragePremium;   

      if(this.quotationResponseModel.kurnia.extraCoverages?.some(x=>x.coverageName == CoveragesConstant.LLOP))
        this.llopPremium = this.quotationResponseModel.kurnia?.extraCoverages.find(x=>x.coverageName == CoveragesConstant.LLOP)?.coveragePremium;   


      this.calculatePremium();
      this.spinner.hide();
    });
  }

  reCalculateChubbAdditionalCoveragePremium(){
    this.spinner.show();

    this.quotationRequestModel.referenceNumber = this.quotationResponseModel.chubb.referenceNumber;

    if (this.form.invalid)     
      return;    

    this.chubbApiService
    .GetQuotation( this.quotationRequestModel)
    .subscribe(response => {
      this.quotationResponseModel.chubb = response.chubb;

      if(!response.success)
      {
        this.showNotification('Unable to get the quotation for now, please contact support', false);
        return;
        
      }
      if(this.quotationResponseModel.chubb.extraCoverages.some(x=>x.coverageName == CoveragesConstant.ALL_DRIVERS))
        this.allDriverPremium  =  this.quotationResponseModel.chubb?.extraCoverages.find(x=>x.coverageName == CoveragesConstant.ALL_DRIVERS)?.coveragePremium;

      if(this.quotationResponseModel.chubb.extraCoverages?.some(x=>x.coverageName == CoveragesConstant.WINDSCREEN))
        this.windScreenPremium = this.quotationResponseModel.chubb?.extraCoverages.find(x=>x.coverageName == CoveragesConstant.WINDSCREEN)?.coveragePremium;

      if(this.quotationResponseModel.chubb.extraCoverages?.some(x=>x.coverageName == CoveragesConstant.SPECIAL_PERILS))
        this.specialPerilsPremium = this.quotationResponseModel.chubb?.extraCoverages.find(x=>x.coverageName == CoveragesConstant.SPECIAL_PERILS)?.coveragePremium;   

      if(this.quotationResponseModel.chubb.extraCoverages?.some(x=>x.coverageName == CoveragesConstant.LLOP))
        this.llopPremium = this.quotationResponseModel.chubb?.extraCoverages.find(x=>x.coverageName == CoveragesConstant.LLOP)?.coveragePremium;   

      this.calculatePremium();
      this.spinner.hide();
    });
  }
  
  reCalculateTuneAdditionalCoveragePremium(){
    this.spinner.show();

    this.quotationRequestModel.referenceNumber = this.quotationResponseModel.tune.referenceNumber;
    this.quotationRequestModel.quoteId = this.quotationResponseModel.tune.otherInformation.quoteId;

    this.tuneApiService
    .GetQuotation( this.quotationRequestModel)
    .subscribe(response => {
      
      this.quotationResponseModel.tune = response.tune;

      if(this.quotationResponseModel.tune.extraCoverages.some(x=>x.coverageName == CoveragesConstant.ALL_DRIVERS))
        this.allDriverPremium  =  this.quotationResponseModel.tune?.extraCoverages.find(x=>x.coverageName == CoveragesConstant.ALL_DRIVERS)?.coveragePremium;

      if(this.quotationResponseModel.tune.extraCoverages?.some(x=>x.coverageName == CoveragesConstant.WINDSCREEN))
        this.windScreenPremium = this.quotationResponseModel.tune?.extraCoverages.find(x=>x.coverageName == CoveragesConstant.WINDSCREEN)?.coveragePremium;

      if(this.quotationResponseModel.tune.extraCoverages?.some(x=>x.coverageName == CoveragesConstant.SPECIAL_PERILS))
        this.specialPerilsPremium = this.quotationResponseModel.tune?.extraCoverages.find(x=>x.coverageName == CoveragesConstant.SPECIAL_PERILS)?.coveragePremium;   

      if(this.quotationResponseModel.tune.extraCoverages?.some(x=>x.coverageName == CoveragesConstant.LLOP))
        this.llopPremium = this.quotationResponseModel.tune?.extraCoverages.find(x=>x.coverageName == CoveragesConstant.LLOP)?.coveragePremium;   

      this.calculatePremium();
      this.spinner.hide();
    });
  }
  
  resetValueStep0(){
    this.quotationRequestModel ={
      dateOfBirth: "",
      extraCoverages : []
    };
  }

  resetValueStep1()
  {
    this.hideDob = false;

    this.isAllRidersChecked = false;
    this.isAllRidersDisabled = false;
    this.allRiderPremium = 0;

    this.isAllDriversChecked = false;
    this.isAllDriversDisabled = false;
    this.allDriverPremium = 0;

    this.isLlopChecked = false;
    this.isLlopDisabled = false;
    this.llopPremium = 7.5;

    this.isSpecialPerilsDisabled = false;
    this.isSpecialPerilsChecked = false;
    this.specialPerilsPremium = 0;

    this.isRoadTaxChecked = false;
    this.disablePhysicalRoadTax = false;
    this.roadTaxAmount = 0;

    this.showRoadTaxRunnerService = false;
    this.showRoadTaxDeliveryService =false;

    this.isWindScreenChecked = false;
    this.isWindscreenDisabled =false;
    this.windScreenform.get("windScreenSumInsured").enable();
    this.windScreenPremium = 0;

    this.totalAmount = 0;
    this.ncdDiscount = 0;
    this.extraCoveragesAmount = 0;
    this.grossPremium = 0;
    this.basicPremium = 0;
    this.stampDuty = 10;
    this.serviceTax = 0;
    this.quotationId = "";
    this.selectedInsurance = "";
    this.policyStartDate = "";
    this.policyEndDate = "";

    this.calculateRoadTaxRequestModel = {};
    this.sumInsuredAmount =0;
    this.minAgreedValue = 0; 
    this.maxAgreedValue = 0;

    this.resetInsuranceLoadedFlag();
  }

  resetInsuranceLoadedFlag()
  {
    this.isZurichLoaded = false;
    this.isAxaLoaded = false;
    this.isKurniaLoaded = false;
    this.isChubbLoaded = false;
    this.isTuneLoaded = false;
  }

  planOnChange($event)
  {
    this.quotationRequestModel.productCode = $event.target.value;
    this.selectedProductCode = $event.target.value;


    if(this.isKurniaSelected())
    {
      this.spinner.show();
      this.quotationRequestModel.referenceNumber = this.quotationResponseModel.kurnia.referenceNumber;

      this.kurniaApiService
      .GetQuotation( this.quotationRequestModel)
      .subscribe(response => {
        this.quotationResponseModel.kurnia.suggestedPremium = response.kurnia?.suggestedPremium;
        this.quotationResponseModel.kurnia.selectedProductCode = response.kurnia?.selectedProductCode;
        this.quotationResponseModel.kurnia.vehicleValueInfo = response.kurnia?.vehicleValueInfo;
        this.quotationResponseModel.kurnia.otherInformation = response.kurnia?.otherInformation;
        this.quotationResponseModel.kurnia.selectedPlan = response.kurnia?.selectedPlan;
        
        if(this.isMotorcycleThirdPartyProductSelected())
          this.quotationRequestModel.sumInsured = 0;

        if(this.isCarThirdPartyFireAndTheftProductSelected())
        {
            this.isWindScreenChecked = false;
            this.windScreenPremium = 0;
            this.isSpecialPerilsChecked = false;
            this.specialPerilsPremium = 0;
            this.isAllDriversChecked = false;
            this.allDriverPremium = 0;
        }
        
        this.getAllRiderPremium();
        this.displaySumInsured();
        this.calculatePremium();
        this.spinner.hide();
      });
    }
    else if(this.isZurichSelected())
    {
      this.spinner.show();
      this.quotationRequestModel.referenceNumber = this.quotationResponseModel.zurich.referenceNumber;

      if(this.isMotorcycleThirdPartyProductSelected())
        this.quotationRequestModel.sumInsured = 0;

      this.zurichApiService
      .GetQuotation( this.quotationRequestModel)
      .subscribe(response => {
        if(response.success){
          this.quotationResponseModel.zurich.suggestedPremium = response.zurich?.suggestedPremium
          this.quotationResponseModel.zurich.selectedProductCode = response.zurich?.selectedProductCode
          this.quotationResponseModel.zurich.selectedPlan = response.zurich?.selectedPlan;
          this.quotationResponseModel.zurich.vehicleValueInfo = response.zurich?.vehicleValueInfo;

          if(this.isCarSelected())
          {
            if(this.isCarThirdPartyFireAndTheftProductSelected())
            {
              this.isWindscreenDisabled = true;
              this.isWindScreenChecked =false;
              this.windScreenPremium = 0;
              this.quotationRequestModel.extraCoverages = this.quotationRequestModel.extraCoverages.filter(x => x.coverageName !== CoveragesConstant.WINDSCREEN);
      
              this.isSpecialPerilsDisabled = true;
              this.isSpecialPerilsChecked = false;
              this.specialPerilsPremium = 0;
              this.quotationRequestModel.extraCoverages = this.quotationRequestModel.extraCoverages.filter(x => x.coverageName !== CoveragesConstant.SPECIAL_PERILS);
      
              this.isAllDriversDisabled = true;
              this.isAllDriversChecked = false;
              this.allDriverPremium = 0;
              this.quotationRequestModel.extraCoverages = this.quotationRequestModel.extraCoverages.filter(x => x.coverageName !== CoveragesConstant.ALL_DRIVERS);
            }
            else{
              this.isWindscreenDisabled = false;
              this.isSpecialPerilsDisabled = false;
              this.isAllDriversDisabled = false;
            }
          }
          else{
   
            this.getAllRiderPremium();
            this.displaySumInsured();
          }
          
          this.calculatePremium();
        }
        else{
          this.showNotification("Required underwriter approval for this plan, please contact our support to change plan or can proceed with current plan.",response.success)
          this.selectedProductCode =  this.quotationResponseModel.zurich?.selectedProductCode;
        }

        this.spinner.hide();
      });
    }
    else if(this.isChubbSelected())
    {
      this.spinner.show();
      this.quotationRequestModel.referenceNumber = this.quotationResponseModel.chubb.referenceNumber;

      this.chubbApiService
      .GetQuotation( this.quotationRequestModel)
      .subscribe(response => {
        this.quotationResponseModel.chubb.suggestedPremium = response.chubb?.suggestedPremium;
        this.quotationResponseModel.chubb.selectedProductCode = response.chubb?.selectedProductCode;
        this.quotationResponseModel.chubb.referenceNumber = response.chubb?.referenceNumber;
        this.quotationRequestModel.referenceNumber = response.chubb?.referenceNumber;
        this.quotationResponseModel.chubb.selectedPlan = response.chubb?.selectedPlan;
        this.quotationResponseModel.chubb.vehicleValueInfo =response.chubb?.vehicleValueInfo;

        this.handleChubbUILogic();
        this.spinner.hide();
        this.calculatePremium();
  
      });
    }
    else if(this.isGeneraliSelected())
    {
      this.spinner.show();
      this.quotationRequestModel.referenceNumber = this.quotationResponseModel.generali?.referenceNumber;

      this.GeneraliApiService
      .GetQuotation( this.quotationRequestModel)
      .subscribe(response => {
        if(response.success){
          this.quotationResponseModel.generali.suggestedPremium = response.generali?.suggestedPremium
          this.quotationResponseModel.generali.selectedProductCode = response.generali?.selectedProductCode
          this.quotationResponseModel.generali.selectedPlan = response.generali?.selectedPlan;
          this.quotationResponseModel.generali.vehicleValueInfo =response.generali?.vehicleValueInfo;

          this.calculatePremium();
        }
        else{
          this.showNotification("Required underwriter approval for this plan, please contact our support to change plan or can proceed with current plan.",response.success)
          this.selectedProductCode =  this.quotationResponseModel.generali?.selectedProductCode;
        }
        this.spinner.hide();
      });
    }
    else if(this.isTuneSelected())
    {
      this.spinner.show();
      this.quotationRequestModel.referenceNumber = this.quotationResponseModel.tune.referenceNumber;
      this.quotationRequestModel.quoteId = this.quotationResponseModel.tune.otherInformation.quoteId;
  

      this.tuneApiService
      .GetQuotation( this.quotationRequestModel)
      .subscribe(response => {
        if(response.success){
          this.quotationResponseModel.tune.suggestedPremium = response.tune?.suggestedPremium
          this.quotationResponseModel.tune.selectedProductCode = response.tune?.selectedProductCode
          this.quotationResponseModel.tune.selectedPlan = response.tune?.selectedPlan;
          this.quotationResponseModel.tune.vehicleValueInfo =response.tune?.vehicleValueInfo;

          if(this.isCarSelected())
          {
           
          }
          else{
   
            this.getAllRiderPremium();
            this.displaySumInsured();
          }
          
          this.calculatePremium();
        }
        else{
         
        }

        this.spinner.hide();
      });
    }
  }
    
  replacePasteValue(event) {
    if(!this.isCompanySelected())
      this.form.patchValue({id:event.clipboardData.getData('Text').replace(/-/g, "").replace(/ /g, "").replace(/{/g, "")});
    else
      this.form.patchValue({id:event.clipboardData.getData('Text').replace(/ /g, "").replace(/{/g, "")});
    
    event.preventDefault();
  }        

  replaceRegistrationNoPasteValue(event) 
  {
    this.form.patchValue({vehicleNo:event.clipboardData.getData('Text').replace(/ /g, "")});
    event.preventDefault();
  }   

  isIdValid()
  {
    if(this.isNricSelected() && 
    this.form.get('id').value.toString().length !=12 )
    {
      this.form.controls['id'].setErrors({ icInvalidLength : true });
      return false;
    }
    else
    {
      this.form.controls['id'].setErrors(null);
      return true;
    }
  }

  getVehicleType()
  {
    if(this.isMotorcycleSelected())
      return "MOTOR";
    else
      return this.vehicleType =="saloon" ? 'SALOON' :'NON-SALOON'
  }

  getShipmentType()
  {
    if(this.isPhysicalRoadTaxSelected())
      return "COURIER";
    else
      return "DIGITAL";
  }

  onCondition1Checked(event)
  {
    if(event.target.checked)
      this.isCondition1Checked = true;
    else
      this.isCondition1Checked = false;

    this.checkPaymentBtn();
  }

  onCondition2Checked(event)
  {
    if(event.target.checked)
      this.isCondition2Checked = true;
    else
      this.isCondition2Checked = false;

    this.checkPaymentBtn();
  }

  onCondition3Checked(event)
  {
    if(event.target.checked)
      this.isCondition3Checked = true;
    else
      this.isCondition3Checked = false;

    this.checkPaymentBtn();
  }

  checkPaymentBtn()
  {    
    if(this.isKurniaSelected() || this.isZurichSelected() || this.isGeneraliSelected() || this.isTuneSelected()){
      if(this.isCondition3Checked && this.isCondition2Checked)
        this.isMakePaymentBtnDisabled = false;
      else
        this.isMakePaymentBtnDisabled = true;
    }
    else{
      if(this.isCondition1Checked && this.isCondition3Checked && this.isCondition2Checked)
        this.isMakePaymentBtnDisabled = false;
      else
        this.isMakePaymentBtnDisabled = true;
    }
  }

  onVehicleTypeClick(value){
    this.vehicleType = value;
    this.calculateRoadTax();
  }

  onRoadTaxTypeClick(value){
    this.roadTaxType = value;

    if(this.isPhysicalRoadTaxSelected()){
      this.showRoadTaxDeliveryService = true;
      this.roadTaxDeliveryService = this.roadTaxSettings.deliveryFeeWithInsurance;
    }
    else{
      this.showRoadTaxDeliveryService = false;
    }
    this.calculateRoadTaxCharges();
    this.calculatePremium();
  }
   
  getFormValidationErrors() {
    Object.keys(this.form.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.form.get(key).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
         console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });
  }

  updateSelectedInsurance(referenceNumber){
    this.updateSelectedInsuranceModel.quotationGroupReferenceNumber = this.verifyVehicleReponseModel.quotationGroupReferenceNumber;
    this.updateSelectedInsuranceModel.referenceNumber = referenceNumber;

    this.quotationService
    .UpdateSelectedInsurance( this.updateSelectedInsuranceModel)
    .subscribe();
  }

  getSelectedInsuranceReferenceNumber(){
    if(this.isZurichSelected())
      return this.quotationResponseModel.zurich.referenceNumber;
    else if(this.isChubbSelected())
      return this.quotationResponseModel.chubb.referenceNumber;  
    else if(this.isKurniaSelected())
      return this.quotationResponseModel.kurnia.referenceNumber;     
    else if(this.isGeneraliSelected())
      return this.quotationResponseModel.generali.referenceNumber;        
  }

  SearchCustomer(){
    this.searchModel.identity = this.form.get('id').value.trim();
    this.searchModel.registrationNo =  this.form.get('vehicleNo').value.trim();
    this.customerApiService
      .getCustomerList(this.searchModel)
      .subscribe(response => {

        if(response.entity.items.length > 0)
        {
          this.form.patchValue({contactNo: response.entity.items[0].contactNo1 },{emitEvent:false})
          this.form.patchValue({postcode: response.entity.items[0].postcode },{emitEvent:false})
          this.form.patchValue({email: response.entity.items[0].email },{emitEvent:false})
        }
        else{
          this.form.patchValue({contactNo: "" },{emitEvent:false})
          this.form.patchValue({postcode: ""  },{emitEvent:false})
          this.form.patchValue({email: ""  },{emitEvent:false})
        }
      });
  }

  getInsuranceCompanyFullName()
  {
    if(this.isChubbSelected())
      return "Chubb Insurance Malaysia Berhad";
    else if(this.isGeneraliSelected())
      return "Generali Insurance Malaysia Berhad’s";
    else if(this.isZurichSelected())
      return "Zurich General Insurance Malaysia";
    else if(this.isKurniaSelected())
      return "Liberty General Insurance Berhad";
    else if(this.isTuneSelected())
      return "Tune Insurance Malaysia Berhad";
  }
  
  getInsuranceCompanyPrivacyPolicyLink()
  {
    if(this.isChubbSelected())
      return "https://www.chubb.com/us-en/online-privacy-policy.html";
    else if(this.isGeneraliSelected())
      return "https://www.generali.com.my/data-privacy-notice";
    else if(this.isZurichSelected())
      return "https://www.zurich.com.my/en/customer-hub/show-me-more-info/personal-data-protection-notice";
    else if(this.isKurniaSelected())
      return "https://www.kurnia.com/privacy-notice/Privacy-Notice-Eng";
  }

  getInsuranceCompanyLink()
  {
    if(this.isChubbSelected())
      return "https://www.chubb.com/";
    else if(this.isGeneraliSelected())
      return "https://www.generali.com.my/";
    else if(this.isZurichSelected())
      return "https://www.zurich.com.my/en/customer-hub/i-want-to-get-in-touch/locate-a-branch";
    else if(this.isKurniaSelected())
      return "https://www.kurnia.com/";    
  }

  getInsuranceCompanyShortName()
  {
    if(this.isChubbSelected())
      return "Chubb";
    else if(this.isGeneraliSelected())
      return "Generali";
   else if(this.isZurichSelected())
      return "Zurich";
  }

  isCarSelected()
  {
    return this.form.get('type').value == "Car";
  }

  isMotorcycleSelected()
  {
    return this.form.get('type').value == "Motorcycle";
  }

  isCompanySelected()
  {
    return this.form.get('idType').value == "Company";
  }

  isPassportSelected()
  {
    return this.form.get('idType').value == "Passport";
  }

  isNricSelected()
  {
    return this.form.get('idType').value == "NRIC";
  }

  isZurichSelected()
  {
    return this.selectedInsurance == InsuranceCompanyConstant.ZURICH;
  }

  isChubbSelected()
  {
    return this.selectedInsurance == InsuranceCompanyConstant.CHUBB;
  }

  isGeneraliSelected()
  {
    return this.selectedInsurance == InsuranceCompanyConstant.GENERALI;
  }

  isKurniaSelected()
  {
    return this.selectedInsurance == InsuranceCompanyConstant.KURNIA;
  }

  isTuneSelected()
  {
    return this.selectedInsurance == InsuranceCompanyConstant.TUNE;
  }

  isPhysicalRoadTaxSelected(){
    return this.roadTaxType == "Physical"
  }

  isDigitalRoadTaxSelected(){
    return this.roadTaxType == "Digital"
  }

  displaySumInsured()
  {
    if(this.isCarSelected())
      return true;
    else if(this.isMotorcycleSelected())
    {
      if(this.isGeneraliSelected())
      {
        //Comprehensive
        if(this.selectedProductCode == "MY|CO")
          return true;
        else
        return false;
      }
      else if(this.isZurichSelected())
      {
        if(this.isMotorcycleThirdPartyProductSelected())
        {
          this.vehicleform.patchValue({suminsured: 0},{emitEvent:false})
          return false;  
        }
        else
          return true;
      }
      else if(this.isKurniaSelected())
      {
        if(this.isMotorcycleThirdPartyProductSelected())
        {
          this.vehicleform.patchValue({suminsured: 0},{emitEvent:false})
          return false;  
        }
        else
          return true;
      }
      else if(this.isTuneSelected())
      {
        if(this.isMotorcycleThirdPartyProductSelected())
        {
          this.vehicleform.patchValue({suminsured: 0},{emitEvent:false})
          return false;  
        }
        else
          return true;
      }
    }
  }

  displayLLOP(){
    return this.isCarSelected();
  }

  displayWindScreen(){
    if (this.isCarSelected()) {
      return !this.isCarThirdPartyFireAndTheftProductSelected();
    }
    return false;
  }

  displayAllDrivers()
  {
    if(this.isCarSelected())
    {
      if(this.isChubbSelected() && 
        this.isCompanySelected())
      {
          this.isAllDriversDisabled = true;
          this.isAllDriversChecked = true;
      }
      
      if(this.isCarThirdPartyFireAndTheftProductSelected())
        return false;
      else
        return true;
    }
    else{
      return false;
    }      
  }

  displayAllRiders()
  {
    if(this.isMotorcycleSelected())
    {
      if(this.isGeneraliSelected() || this.isTuneSelected())
        return false;
      else
        return true;  
    }
    else{
      return false;
    }      
  }

  displaySpecialPerils(){
    if(this.isCarSelected())
    {
      if(this.isCarThirdPartyFireAndTheftProductSelected())
        return false;
      else
        return true;
    }
    else{
      return false;
    }
  }

  isCarThirdPartyFireAndTheftProductSelected()
  {
    if(this.isCarSelected())
    {
      if(this.isGeneraliSelected())
      {
        if(this.quotationResponseModel.generali?.selectedProductCode == "MX|TF")
          return true;
        else
          return false;
      }
      else if(this.isKurniaSelected())
      {
        if(this.quotationResponseModel.kurnia?.selectedProductCode == "TPFT")
          return true;
        else
          return false;
      }
      else if(this.isZurichSelected())
      {
        if(this.quotationResponseModel.zurich?.selectedProductCode == "V-FT")
          return true;
        else
          return false;
      }
      else if(this.isTuneSelected())
      {
        if(this.quotationResponseModel.tune?.selectedProductCode == "Plus")
          return true;
        else
          return false;
      }
    }
  }

  isMotorcycleThirdPartyProductSelected()
  {
    if(this.isMotorcycleSelected())
    {
      if(this.isGeneraliSelected())
      {
        if(this.quotationResponseModel.generali?.selectedProductCode == "MY|TP")
          return true;
        else
          return false;
      }
      else if(this.isKurniaSelected())
      {
        if(this.quotationResponseModel.kurnia?.selectedProductCode == "TP")
          return true;
        else
          return false;
      }
      else if(this.isZurichSelected())
      {
        if(this.quotationResponseModel.zurich?.selectedProductCode == "V-TP")
          return true;
        else
          return false;
      }
      else if(this.isTuneSelected())
      {
        if(this.quotationResponseModel.tune?.selectedProductCode == "Plus")
          return true;
        else
          return false;
      }
    }
  }

  isLoginAsAdmin()
  {
    var result = this.currentUser?.name != null;

    if(!result)
      this.form.patchValue({source:"0"});

    return result;
  }

  submitQuotation(){
    this.pdfSubmitted = true;

    if (this.personalDetailsForm.invalid)  
      return;    

    this.spinner.show();

    let contactNo = this.personalDetailsForm.get('contactNo1')?.value?.trim();

    if (contactNo && !contactNo.startsWith('6')) {
      contactNo = '6' + contactNo;
    }

    var actualRoadTaxDeliveryService =  this.getRoadTaxDeliveryService();
    var actualRoadTaxAmount =  this.getRoadTaxAmount();
    var actualRoadTaxRunnerService = this.getRoadTaxRunnerService();
    var actualRoadTaxServiceCharge = this.getRoadTaxServiceCharge();
    var paymentLog =  this.generateSummary();

    const payload = new HttpParams()
    .set('accessToken', 'eTdy1nT7TcOTp7LCDISfNteHWpZHketK')
    .set('module',  '/sales/insert')
    .set('clientIdNo',  this.form.get('id').value.trim())
    .set('clientIdType',   this.form.get('idType').value.toUpperCase().trim())
    .set('clientName',   this.personalDetailsForm.get('name').value.trim())
    .set('contactNo',  contactNo)
    .set('vehicleType', this.getVehicleType())
    .set('vehicleNo', this.form.get('vehicleNo').value.trim())
    .set('quoteProvider', this.selectedInsurance)
    .set('premAmount', this.totalPremium)
    .set('roadTaxMonth', this.isRoadTaxChecked ? 12 : 0)
    .set('roadTaxAmount', actualRoadTaxAmount.toString()) 
    .set('shipmentType', this.getShipmentType()) 
    .set('shipmentFee', (actualRoadTaxDeliveryService).toString()) 
    .set('deliveryAddress', this.personalDetailsForm.get('address1').value.trim()+" "+ this.personalDetailsForm.get('address2').value.trim()+this.personalDetailsForm.get('postcode').value.trim()) 
    .set('notesPublic',  this.personalDetailsForm.get('remark').value.trim())
    .set('insurance',  paymentLog)
    .set('tin', this.personalDetailsForm.get('tin').value)
    .set('sstregno', this.personalDetailsForm.get('sstRegNo').value)
    .set('clientExpiryDate',  this.verifyVehicleReponseModel.vehicleInfo.previousPolicyEndDateYYYYMMDD)
    fetch("https://bmsroadtax.com/api/v3/index.php", {
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        body:  payload.toString()
    })
    .then(res =>res.text())
    .then((body) => {
    
       let jsonObj = JSON.parse(body);
       let paymentModel = jsonObj as PaymentResponseModel;

      this.customerInfoModel.name = this.personalDetailsForm.get('name').value.trim();
      this.customerInfoModel.email = this.personalDetailsForm.get('email').value.trim();
      this.customerInfoModel.contactNo1 = this.personalDetailsForm.get('contactNo1').value.trim();
      this.customerInfoModel.contactNo2 = this.personalDetailsForm.get('contactNo2').value.trim();
      this.customerInfoModel.address1 = this.personalDetailsForm.get('address1').value.trim();
      this.customerInfoModel.address2 = this.personalDetailsForm.get('address2').value.trim();
      this.customerInfoModel.postcode = this.personalDetailsForm.get('postcode').value.trim();
      this.customerInfoModel.state = this.personalDetailsForm.get('state').value.trim();
      this.customerInfoModel.remark = this.personalDetailsForm.get('remark').value.trim();
      this.customerInfoModel.identity = this.form.get('id').value.trim();
      this.customerInfoModel.identityType = this.form.get('idType').value.trim();
      this.customerInfoModel.maritalStatus =  this.personalDetailsForm.get('maritalStatus').value.trim();
      this.vehicleInfoModel.isSaloon =  this.vehicleType =="saloon" ? true : false;

      this.customerInfoModel.einvoiceInfo.tin =  this.personalDetailsForm.get('tin').value;
      this.customerInfoModel.einvoiceInfo.sstRegNo =  this.personalDetailsForm.get('sstRegNo').value;
      this.customerInfoModel.einvoiceInfo.msicCode =  this.personalDetailsForm.get('msicCode').value;
      this.customerInfoModel.einvoiceInfo.optInEinvoice =  this.personalDetailsForm.get('compulsoryOptInForEinvoice').value == "true" ? true : false  ;
      this.actualPremiumModel = {};

      this.actualPremiumModel.basicPremium = this.basicPremium;
      this.actualPremiumModel.ncdAmount = this.ncdDiscount;
      this.actualPremiumModel.windscreen = this.isWindScreenChecked ? this.windScreenPremium : 0;
      this.actualPremiumModel.windscreenSumInsured = this.isWindScreenChecked ? this.windScreenform.get('windScreenSumInsured').value : 0;
      this.actualPremiumModel.llop = this.isLlopChecked ? this.llopPremium : 0;
      this.actualPremiumModel.allDrivers = this.isAllDriversChecked ? this.allDriverPremium : 0;
      this.actualPremiumModel.allRiders = this.isAllRidersChecked ? this.allRiderPremium : 0;
      this.actualPremiumModel.specialPerils = this.isSpecialPerilsChecked ? this.specialPerilsPremium : 0;
      this.actualPremiumModel.sumInsured = this.sumInsuredAmount;
      this.actualPremiumModel.grossPremium = this.grossPremium;
      this.actualPremiumModel.serviceTax = this.serviceTax;
      this.actualPremiumModel.stampDuty = this.stampDuty;
      this.actualPremiumModel.loading = this.loading;
      this.actualPremiumModel.quotationTotal = this.totalPremium;

      this.actualPremiumModel.roadTaxType = this.isPhysicalRoadTaxSelected() ? 0 : 1;
      this.actualPremiumModel.roadTaxRenewal = actualRoadTaxAmount;
      this.actualPremiumModel.roadTaxRenewalMonth = 12 ;
      this.actualPremiumModel.roadTaxDeliveryService = actualRoadTaxDeliveryService;
      this.actualPremiumModel.roadTaxRunnerService = actualRoadTaxRunnerService;
      this.actualPremiumModel.roadTaxServiceCharge = actualRoadTaxServiceCharge;
      this.actualPremiumModel.shippingOption = 1;
      this.actualPremiumModel.totalPaid =  this.totalAmount;
      this.actualPremiumModel.paymentLog = paymentLog;
      this.agentModel = {};

      if( this.currentUser != null && this.currentUser != undefined)
      {
        if(this.currentUser.role == "Agent")
          this.agentModel.agentId = this.currentUser.id;
      }

      this.quotationResponseModel.customerInfo =  this.customerInfoModel;
      this.quotationResponseModel.agentInfo =  this.agentModel;
      this.quotationResponseModel.vehicleInfo =  this.vehicleInfoModel;
      
      if(this.selectedInsurance ==InsuranceCompanyConstant.ZURICH)
      {
        this.quotationResponseModel.zurich.actualPremium = this.actualPremiumModel;
        this.quotationResponseModel.zurich.bmsOrderNo = paymentModel.data.orderNo;
        this.quotationResponseModel.zurich.bmsSalesId =  paymentModel.data.saleId;
      }
      else if(this.selectedInsurance ==InsuranceCompanyConstant.CHUBB)
      {

        this.quotationResponseModel.chubb.actualPremium = this.actualPremiumModel;
        this.quotationResponseModel.chubb.bmsOrderNo = paymentModel.data.orderNo;
        this.quotationResponseModel.chubb.bmsSalesId =  paymentModel.data.saleId;
      }
      else if(this.selectedInsurance ==InsuranceCompanyConstant.GENERALI)
      {
        this.quotationResponseModel.generali.actualPremium = this.actualPremiumModel;
        this.quotationResponseModel.generali.bmsOrderNo = paymentModel.data.orderNo;
        this.quotationResponseModel.generali.bmsSalesId =  paymentModel.data.saleId;
      }
      else if(this.selectedInsurance ==InsuranceCompanyConstant.KURNIA)
      {
        this.quotationResponseModel.kurnia.actualPremium = this.actualPremiumModel;
        this.quotationResponseModel.kurnia.bmsOrderNo = paymentModel.data.orderNo;
        this.quotationResponseModel.kurnia.bmsSalesId =  paymentModel.data.saleId;
      }
      else if(this.selectedInsurance ==InsuranceCompanyConstant.TUNE)
      {
        this.quotationResponseModel.tune.actualPremium = this.actualPremiumModel;
        this.quotationResponseModel.tune.bmsOrderNo = paymentModel.data.orderNo;
        this.quotationResponseModel.tune.bmsSalesId =  paymentModel.data.saleId;
      }


      this.quotationService
      .UpdatePayment( this.quotationResponseModel)
      .subscribe(response => {
        this.spinner.hide();
        window.location.href = "https://bmsroadtax.com/#order/"+  encode(paymentModel.data.orderNo); ;
      });

    })
    .catch((error) => {
      this.spinner.hide();  
      console.log(error)   ;
      this.showNotification("Payment gateway error, please contact support",false);
    });
  }

  generateSummary()
  {
    return JSON.stringify({
      sumInsured: this.sumInsuredAmount.toLocaleString("en-US"),
      basicPremium: this.basicPremium.toLocaleString("en-US"),
      loading: this.loading.toLocaleString("en-US"),
      ncd: this.ncdDiscount.toLocaleString("en-US"),
      ncdPerc: this.ncdPerc.toLocaleString("en-US"),
      planPremium: this.planPremium.toLocaleString("en-US"),
      extraCoverages:{
        allRider: this.isAllRidersChecked ? this.allRiderPremium.toLocaleString("en-US") : (0).toLocaleString("en-US"),
        allDriver: this.isAllDriversChecked ? this.allDriverPremium.toLocaleString("en-US") : 0,
        specialPerils: this.isSpecialPerilsChecked ? this.specialPerilsPremium.toLocaleString("en-US") : 0,
        llop: this.isLlopChecked ? this.llopPremium.toLocaleString("en-US") : 0,
        lltp: 0,
        eHailing: 0,
        bettermentWaiver: 0,
        thailandExtension: 0,
        cart: 0,
        windscreen: this.isWindScreenChecked ? this.windScreenPremium.toLocaleString("en-US") : 0,
        windscreenSumInsured: this.isWindScreenChecked ? this.windScreenform.get('windScreenSumInsured').value.toLocaleString("en-US") : 0,
      },
      personalAccident: 0,
      personalAccidentPlan: "",
      grossPremium: this.grossPremium.toLocaleString("en-US"),
      commission: this.commission.toLocaleString("en-US"),
      serviceTax: this.serviceTax.toLocaleString("en-US"),
      stampDuty: this.stampDuty.toLocaleString("en-US"),
      NettPremium: this.totalPremium.toLocaleString("en-US"),
      plan: this.selectedPlan
    })
  }
 
  vehicleTypeOnChange(data)
  {
    this.verifyVehicleReponseModel.vehicleInfo.isSaloon = data == "true" ? true : false;
    this.calculateRoadTax();
  }

  submitSpecialRequest(){
    this.updateQuotationSpecialRequestModel.referenceNumber = this.verifyVehicleReponseModel.quotationGroupReferenceNumber;
    this.updateQuotationSpecialRequestModel.specialRequest = this.specialRequestForm.get('specialRequest').value.trim();;

    this.quotationService
    .UpdateQuotationSpecialRequest( this.updateQuotationSpecialRequestModel)
    .subscribe(x => {
      this.showNotification("We have receive your request and will contact you shortly",true);  
    }
    );
  }

  getCountries(){
      this.countryService.GetCountries()
      .subscribe(response => {
          this.countryList = response;
      });
  }

  getMsicCode(){
    if(this.isKurniaSelected())
    {
      this.msicService.GetMsicCode()
      .subscribe(response => {
          this.msicList = response;
      });
    }
  }

  handleChubbUILogic()
  {
      if(this.quotationResponseModel.chubb.selectedProductCode =="B")
      {
        this.isSpecialPerilsChecked = true;
        this.isSpecialPerilsDisabled = true;
        this.specialPerilsPremium = this.quotationResponseModel.chubb.suggestedPremium.specialPerils;      
      }
      else
      {
        this.isSpecialPerilsDisabled = false;
      }
  }

  displayEinvoiceRequiredOption()
  {
    return !this.compulsoryOptInForEinvoice;
  }

  displayEinvoiceSession()
  {
    if( this.compulsoryOptInForEinvoice &&   
        (this.isKurniaSelected() ||this.isChubbSelected()) )
    {      
      return true;
    }

    else
    {
      if(this.personalDetailsForm.get('compulsoryOptInForEinvoice').value == "true")
        return true;
      else 
        return false;
    }

  }

  compulsoryOptInForEinvoiceOnChange(value)
  {
    if(value)
    {      
      if(this.isCompanySelected() )
      {
        this.personalDetailsForm.get('msicCode').setValidators(Validators.required);
        this.personalDetailsForm.get('msicCode').updateValueAndValidity();    
      }      
      else
      {
      
        this.personalDetailsForm.patchValue({msicCode: "00000"})
      }
      this.personalDetailsForm.get('tin').addValidators(Validators.required);
      this.personalDetailsForm.get('tin').updateValueAndValidity();

    }

    else
    {
       this.personalDetailsForm.get('msicCode').setValidators(null);
      this.personalDetailsForm.get('msicCode').updateValueAndValidity();
      this.personalDetailsForm.get('tin').setValidators(null);
      this.personalDetailsForm.get('tin').updateValueAndValidity();

    }
  }

  getTunePolicyWordingAndPds(){
    if(this.isCarSelected())
    {
      this.getTunePolicyWording = InsuranceDocumentConstant.Tune_Car_PW;
      this.getTuneProductDisclosureLink = InsuranceDocumentConstant.Tune_Car_PDS;
    }
    else{
      this.getTunePolicyWording = InsuranceDocumentConstant.Tune_Bike_PW;
      this.getTuneProductDisclosureLink =  InsuranceDocumentConstant.Tune_Bike_PDS;
    }
  }
}
